import { defineMessages } from 'react-intl';

export default defineMessages({
    signoutMessage: {
        id: 'ExitConfirmationPage.You have been signed out successfully.',
        defaultMessage: 'You have been signed out successfully.'
    }
});
